import { VolumeSet } from "../../../../schema/types/volumeSet/entity";

export function VolumeSetSharedTag(item: VolumeSet): string {
  try {
    if (item.spec.fileSystemType === "shared") {
      return "shared";
    }
    return "";
  } catch (e) {
    return "";
  }
}
